import { useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import heroAIConsultingMobile from '@/assets/hero-ai-consulting-mobile.webp';

/**
 * Critical Image Preloader for LCP optimization
 * Preloads the hero image for mobile to improve LCP
 */
export const CriticalImagePreloader = () => {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) return;

    // Preload the critical LCP image for mobile using the imported asset path
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.type = 'image/webp';
    link.href = heroAIConsultingMobile; // Use the imported asset path with correct hash
    link.fetchPriority = 'high' as any;
    
    // Only add if not already present
    const existingPreload = document.querySelector(`link[href="${heroAIConsultingMobile}"]`);
    if (!existingPreload) {
      document.head.appendChild(link);
    }

    return () => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    };
  }, [isMobile]);

  return null;
};
